import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

interface ChartData {
  month: string;
  income: number;
  expense: number;
}

interface IncomeExpenseChartProps {
  data: ChartData[];
}

export function IncomeExpenseChart({ data }: IncomeExpenseChartProps) {
  // If no data, show empty state
  if (!data || data.length === 0) {
    return (
      <div className="w-full h-64 flex items-center justify-center border border-dashed border-muted-foreground/25 rounded-lg bg-muted/5">
        <div className="text-center text-muted-foreground">
          <p className="text-sm">No performance data available</p>
          <p className="text-xs mt-1">
            Add transactions to see income vs expense trends
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="income" fill="#4ade80" name="Income" />
          <Bar dataKey="expense" fill="#f87171" name="Expense" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
